import { statsOnWidgetInteraction } from '../stats';

export function hotpoints() {
  if (document.querySelectorAll('.hotpoints').length) {
    document.querySelectorAll('.hotpoints').forEach((slider) => {
      const desc = document.createElement('div');
      desc.classList.add('hotpoint-slider__text');
      slider.append(desc);
      const firstPin = slider.querySelectorAll('.hotpoints__poi')[0];
      desc.innerHTML = firstPin.querySelector('.hotpoints__poi_txt').innerHTML;
      firstPin.classList.add('__jsActive');
      slider.querySelectorAll('.hotpoints__poi').forEach((pin) => {
        if (Number(pin.getAttribute('data-position-left')) > 70) {
          pin.querySelector('.hotpoints__poi_txt').classList.add('__left');
        }
        if (Number(pin.getAttribute('data-position-left')) < 30) {
          pin.querySelector('.hotpoints__poi_txt').classList.add('__right');
        }
        if (Number(pin.getAttribute('data-position-top')) < 50) {
          pin.querySelector('.hotpoints__poi_txt').classList.add('__up');
        }
        if (Number(pin.getAttribute('data-position-top')) >= 50) {
            pin.querySelector('.hotpoints__poi_txt').classList.add('__down');
        }

        pin.style.top = `${pin.getAttribute('data-position-top')}%`;
        pin.style.left = `${pin.getAttribute('data-position-left')}%`;
        pin.addEventListener('mouseenter', () => {
          slider.querySelectorAll('.hotpoints__poi').forEach((el) => {
            el.classList.remove('__jsActive');
          });
          desc.innerHTML = pin.querySelector('.hotpoints__poi_txt').innerHTML;
          pin.classList.add('__jsActive');
          statsOnWidgetInteraction(pin, pin.querySelector('.hotpoints__poi_txt').innerText);
        });
      });
    });
  }
}
